import { IGetPromoProductsByPromoEventIdParams, IPromotionRepository, IPromoProductsByPromoEventIdPaginatedResponse } from "@/core/repositories/promotion";


export class GetPromoProductsByPromoEventIdUseCase {
  constructor(private readonly repo: IPromotionRepository) {}

  async execute(params: IGetPromoProductsByPromoEventIdParams, refetch = false): Promise<IPromoProductsByPromoEventIdPaginatedResponse> {
    return this.repo.getPromoProductsByPromoEventId(params, refetch);
  }
}
